export const getProductDataForBatchedAnalytics = (event: any) => ({
  product_id: event.productId,
  color: event.color,
  product_options: event.productOptions,
  tags: event.tags,
  oos_flag: event?.oos_flag,
  name: event?.name,
  color_variant: event?.color_variant,
  count_color_variant: event?.count_color_variant,
  rating: event?.rating,
  wishlishted: event?.wishlishted,
  is_new: event?.is_new,
  back_in_stock: event?.back_in_stock,
  sold_out: event?.sold_out,
  low_stock: event?.low_stock,
  best_seller: event?.best_seller,
  shopifyProductId: event?.shopifyProductId,
  productProperties: event?.productProperties,
  edd_standard_eligible: event?.edd_standard_eligible,
  edd_express_eligible: event?.edd_express_eligible,
  edd_max_days: event?.edd_max_days,
  edd_min_days: event?.edd_min_days,
  leaving_soon: event?.leaving_soon,
})
